import {
  format,
  subDays,
  subHours,
  subMonths,
  subWeeks,
  startOfDay,
  endOfDay,
  startOfMonth,
  endOfMonth,
} from "date-fns";

export type DurationDates = {
  from: Date;
  to: Date;
};

export const assignDatesToDuration = (
  durationId: string
): DurationDates | null => {
  const now = new Date();

  switch (durationId) {
    case "today": {
      return {
        from: startOfDay(now),
        to: endOfDay(now),
      };
    }
    case "last-24-hours": {
      return {
        from: subHours(now, 24),
        to: now,
      };
    }
    case "last-7-days": {
      return {
        from: startOfDay(subDays(now, 6)),
        to: endOfDay(now),
      };
    }
    case "last-30-days": {
      return {
        from: startOfDay(subDays(now, 30)),
        to: endOfDay(now),
      };
    }
    case "last-3-months": {
      return {
        from: startOfDay(subMonths(now, 3)),
        to: endOfDay(now),
      };
    }
    case "last-6-months": {
      return {
        from: startOfDay(subMonths(now, 6)),
        to: endOfDay(now),
      };
    }
    case "last-week": {
      return {
        from: startOfDay(subWeeks(now, 1)),
        to: endOfDay(now),
      };
    }
    case "last-month": {
      const lastMonth = subMonths(now, 1);
      return {
        from: startOfMonth(lastMonth),
        to: endOfMonth(lastMonth),
      };
    }
    case "this-month": {
      return {
        from: startOfMonth(now),
        to: endOfDay(now), // Changed to today instead of end of month
      };
    }
    case "last-1-year": {
      const fromYear = new Date(now);
      fromYear.setFullYear(fromYear.getFullYear() - 1);
      return {
        from: startOfDay(fromYear),
        to: endOfDay(now),
      };
    }
    case "custom": {
      return null;
    }
    default:
      return null;
  }
};

export const formatDate = (date: Date | null): string => {
  if (!date) return "";
  return format(date, "yyyy-MM-dd HH:mm:ss");
};
